import MovableItemActionResult from 'app/src/engine/action-results/MovableItemActionResult';
import MovableItem, { MovableItemLocation } from 'app/src/engine/movable-items/MovableItem';
import Robot from 'app/src/engine/movable-items/Robot';
import GameStateStore from 'app/src/game/GameStateStore';

export enum MoveMovableItemActionResultType {
	Drive,
	Pushed,
	Convey,
}

export enum MoveMovableItemActionResultResult {
	Move,
	Bounce,
	Fall,
}

export enum MoveMovableItemActionResultDirection {
	Up,
	Right,
	Down,
	Left,
}

export enum MoveMovableItemActionResultApproachingTileFromDirection {
	FromTop,
	FromRight,
	FromBottom,
	FromLeft,
}

export default class MoveMovableItemActionResult extends MovableItemActionResult {
	public oldLocation: MovableItemLocation;
	public newLocation: MovableItemLocation;

	public movementType = MoveMovableItemActionResultType.Drive;
	public movementResult = MoveMovableItemActionResultResult.Move;
	public movementDirection = MoveMovableItemActionResultDirection.Up;

	public killsItem = false;
	public removesItemFromGame = false;

	constructor(movableItem: MovableItem, oldLocation: MovableItemLocation) {
		super(movableItem);

		this.oldLocation = oldLocation;
		this.newLocation = oldLocation;
	}

	// Update the location of the movableItem. If the result calls for killing the
	// robot, kill him. Same goes for removing him. If the result calls to end
	// future segments, clear the segment queue.
	public execute(gameStateStore: GameStateStore): void {
		// Everything is finished with the potential movement. Set it back to the
		// movableItem's data.
		gameStateStore.moveItem(this.movableItem, this.newLocation);

		// Handle killing items.
		if (this.killsItem && this.movableItem instanceof Robot) {
			gameStateStore.killRobot(this.movableItem);
		}

		// Handle removing items from the board.
		if (this.removesItemFromGame) {
			// TODO: Figure out if we should be removing these. This currently screws
			// with animations since the instant it's removed from the list, it
			// disappears from the map and doesn't have a chance to be animated to its
			// death.
			// gameStateStore.removeMovableItem(this.movableItem);
		}
	}

	// InstructionSegments may use this convenience function to ask tiles to
	// transform MoveMovableItemActionResults. If the MovableItem is remaining on
	// the tile, only that tile will be called to transform the action result.
	// Otherwise, both the tile being left and the one being entered will have the
	// opportunity.
	public askTileToTransform(gameStateStore: GameStateStore): void {
		// Ask the current tile if there should be any action result type
		// transformations.
		const oldTile = gameStateStore.getTile(this.oldLocation.row, this.oldLocation.col);
		const newTile = gameStateStore.getTile(this.newLocation.row, this.newLocation.col);

		if (
			this.oldLocation.row === this.newLocation.row &&
			this.oldLocation.col === this.newLocation.col
		) {
			oldTile.transformActionResultWhenRemaining(this);
		} else {
			oldTile.transformActionResultWhenLeaving(this);
			newTile.transformActionResultWhenEntering(this);
		}
	}

	public clone(): MoveMovableItemActionResult {
		const newActionResult = new MoveMovableItemActionResult(this.movableItem, this.oldLocation);

		newActionResult.oldLocation = this.oldLocation;
		newActionResult.newLocation = this.newLocation;

		newActionResult.movementType = this.movementType;
		newActionResult.movementResult = this.movementResult;
		newActionResult.movementDirection = this.movementDirection;

		newActionResult.killsItem = this.killsItem;
		newActionResult.removesItemFromGame = this.removesItemFromGame;

		return newActionResult;
	}
}
